import script from "./RealtimeDataHistoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./RealtimeDataHistoryView.vue?vue&type=script&setup=true&lang=js"

import "./RealtimeDataHistoryView.vue?vue&type=style&index=0&id=a4c47b84&lang=css"

const __exports__ = script;

export default __exports__